import { StateInterface } from "./state";
import { ProjectModel } from "../models";
import { FileEntryModel } from "../models/fileEntry";

export default {
  allProjects(state: StateInterface): ProjectModel[] {
    return state.projects;
  },
  allSubscriptions(state: StateInterface): ProjectModel[] {
    return state.subscriptions;
  },
  activeSubscriptions(state: StateInterface): ProjectModel[] {
    return state.subscriptions.filter((s): boolean => s.isActive());
  },
  lastFive(state: StateInterface): ProjectModel[] {
    return state.projects
      .sort((a, b): number => {
        if (a.projectId > b.projectId) return -1;
        if (a.projectId < b.projectId) return 1;
        return 0;
      })
      .slice(0, 5);
  },
  project:
    (state: StateInterface): ((_: number) => ProjectModel) =>
    (id: number): ProjectModel => {
      if (id in state.project) {
        return state.project[id];
      }
      return new ProjectModel();
    },
  fileEntries:
    (state: StateInterface): ((_: number) => FileEntryModel[]) =>
    (id: number): FileEntryModel[] => {
      if (id in state.fileEntriesForProjects) {
        return state.fileEntriesForProjects[id];
      }
      return [];
    },
};
